import React from 'react'
import './App.css'
import AppRouter from './router'
import { ClaimProvider } from './claimProvider'
import Toast from './components/ui/Toast'

function App() {
    return (
        <ClaimProvider>
            <div className="App">
                <Toast />
                <AppRouter />
            </div>
        </ClaimProvider>
    )
}

export default App
